import React from 'react';

const Gallery = () => {
  const images = [
    '/images/gallery/gallery3.jpeg',
    '/images/gallery/gallery4.jpeg',
    '/images/gallery/gallery5.jpeg',
    '/images/gallery/gallery6.jpeg',
    '/images/gallery/gallery7.jpeg',
    '/images/gallery/gallery8.jpeg',
    '/images/gallery/gallery9.jpeg',
    '/images/gallery/gallery10.jpeg',
    '/images/gallery/gallery11.jpeg'
  ];

  return (
    <div className="gallery-container">
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item">
            <img src={image} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
